import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
    selector: '[appCnpjValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: CnpjValidatorDirective,
        multi: true
    }]
})
export class CnpjValidatorDirective implements Validator {
        
    validate(control: AbstractControl) : {[key: string]: any} | null {
        if (!this.cnpjValidator(control.value)) {
            return { 'cnpjInvalid': true };
        }
        return null;
    }

    cnpjValidator(cnpj: string){
        console.log('cnpj', cnpj);
        return new RegExp(/^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/).test(cnpj);
    }
}